import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import * as React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import { Button, Offline, OfflinePlaceholder, Online, Overlay, PasswordResetForm } from "../..";
import { baseUrl } from "../../../app/routes";
import mailSend from "../../../images/mail-send.svg";
import closeImg from "../../../images/x.svg";
import { OverlayTheme, OverlayType } from "../../Overlay/context";
import { commonMessages } from "../../../intl";

var Password = function Password(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();
  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "password-reset"
  }, React.createElement(Online, null, React.createElement("div", {
    className: "overlay__header"
  }, React.createElement(ReactSVG, {
    path: closeImg,
    onClick: overlay.hide,
    className: "overlay__header__close-icon"
  })), React.createElement("div", {
    className: "password-reset__content"
  }, React.createElement(PasswordResetForm, {
    onSuccess: function onSuccess() {
      overlay.show(OverlayType.popupMessage, OverlayTheme.modal, {
        data: {
          content: React.createElement(React.Fragment, null, React.createElement(Link, {
            to: baseUrl
          }, React.createElement(Button, {
            onClick: overlay.hide,
            className: "red",
            type: "button"
          }, intl.formatMessage(_defineProperty({
            defaultMessage: "go to homepage",
            "id": "components.OverlayManager.Password.index.788127442"
          }, "id", "components.OverlayManager.Password.index.788127442"))))),
          image: mailSend,
          text: intl.formatMessage(_defineProperty({
            defaultMessage: "A link to change your password is knocking at your door! Just open your e-mail!",
            "id": "components.OverlayManager.Password.index.2057140338"
          }, "id", "components.OverlayManager.Password.index.2057140338")),
          title: intl.formatMessage(commonMessages.success)
        }
      });
    }
  }))), React.createElement(Offline, null, React.createElement(OfflinePlaceholder, null))));
};

export default Password;